import { render, staticRenderFns } from "./render-panorama-invoice-status-value.vue?vue&type=template&id=5924cb0c&scoped=true"
import script from "./render-panorama-invoice-status-value.vue?vue&type=script&lang=js"
export * from "./render-panorama-invoice-status-value.vue?vue&type=script&lang=js"
import style0 from "./render-panorama-invoice-status-value.vue?vue&type=style&index=0&id=5924cb0c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5924cb0c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/nortonpigozzo/Development/nisoftwares/VeinsEnergia-api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5924cb0c')) {
      api.createRecord('5924cb0c', component.options)
    } else {
      api.reload('5924cb0c', component.options)
    }
    module.hot.accept("./render-panorama-invoice-status-value.vue?vue&type=template&id=5924cb0c&scoped=true", function () {
      api.rerender('5924cb0c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/modules/panorama/components/render-panorama-invoice-status-value.vue"
export default component.exports